import type { ContentDocument } from "src/services/diagnosticService";
import { fibBlanks } from "src/components/assessment/ContentBlocks";

interface FibInputProps {
  content: ContentDocument;
  value: Record<string, string>;
  onChange: (value: Record<string, string>) => void;
}

export function FibInput({ content, value, onChange }: FibInputProps) {
  const blanks = fibBlanks(content);

  return (
    <div className="flex flex-col gap-4">
      {blanks.map((blank) => (
        <label key={blank.id} className="flex flex-col gap-1.5 text-sm font-medium text-[#3e1168]">
          {blank.label}
          <input
            aria-label={blank.label}
            value={value[blank.id] ?? ""}
            onChange={(event) => onChange({ ...value, [blank.id]: event.target.value })}
            className="h-11 rounded-md border border-input bg-white px-3 text-base font-normal text-[#241432] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            inputMode="decimal"
            autoComplete="off"
          />
        </label>
      ))}
    </div>
  );
}

export default FibInput;
